import { ArrowLeft } from 'lucide-react'
import { Link, useParams } from 'react-router-dom'
import { LessonAnalyticsDashboard } from '@/components/analytics/LessonAnalyticsDashboard'
import { Button } from '@/components/ui/button'
import { Skeleton } from '@/components/ui/skeleton'
import { useLesson } from '@/hooks/use-lessons'
import { useTenantPath } from '@/lib/tenant'

export default function TeacherLessonAnalyticsPage() {
  const { id } = useParams<{ id: string }>()
  const { data: lesson, isLoading } = useLesson(id ?? '')
  const tp = useTenantPath()

  if (!id) return null

  if (isLoading) {
    return (
      <div className="space-y-6">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-96" />
      </div>
    )
  }

  const lessonTitle = (lesson as any)?.title ?? 'レッスン'

  return (
    <div className="space-y-6">
      <Link to={tp('/teacher/lessons')}>
        <Button variant="ghost" size="sm" className="gap-2">
          <ArrowLeft className="h-4 w-4" />
          レッスン一覧に戻る
        </Button>
      </Link>
      <LessonAnalyticsDashboard lessonId={id} lessonTitle={lessonTitle} />
    </div>
  )
}
